<template>
  <div>
    <div class="d-flex justify-space-between align-center text-left ">
      <div class="d-flex justify-start">
        <a :href="link" target="_blank" class="text-decoration-none">
          <v-avatar color="grey">
            <img v-if="chat.image" :src="chat.image" />
            <v-icon v-else>mdi-account-group</v-icon>
          </v-avatar>
        </a>

        <div class="w-100 pb-2 ml-3">
          <div class="d-flex justify-space-between ">
            <div>
              <a :href="link" class="text-decoration-none" target="_blank">
                <h4 class="p-text navy--text">{{ chat.title }}</h4>
                <div>{{ capitalize(chat.type) }}</div>
              </a>
            </div>
          </div>
          <span v-if="['SUPPORT', 'COACH'].includes(chat.type) && clientLastRead(chat)" class="block">
            Last viewed <b>{{ clientLastRead(chat) }}</b>
          </span>
          <span v-if="timeAgo"
            >Last message <b>{{ timeAgo }}</b></span
          >
        </div>
      </div>
      <v-btn :href="link" target="_blank" outlined color="secondary">Open</v-btn>
    </div>
    <div class="d-flex justify-space-between align-center">
      <div>
        <a :href="link" class="text-decoration-none" target="_blank">
          <div v-if="chat.lastMessage" class="p-text" :class="{ 'font-weight-bold': chat.unreadCount > 0 }">
            <span v-if="chat.participantCount > 2">{{ chat.lastMessage.user.firstName }}: </span>
            <span
              v-if="
                chat.lastMessage.messageattachmentSet.length > 0 &&
                  chat.lastMessage.messageattachmentSet[0].type == 'AUDIO'
              "
              class="pr-1"
            >
              <v-icon> mdi-microphone </v-icon></span
            >
            <span
              v-if="
                chat.lastMessage.messageattachmentSet.length > 0 &&
                  chat.lastMessage.messageattachmentSet[0].type == 'VIDEO'
              "
              class="pr-1"
            >
              <v-icon> mdi-video </v-icon></span
            >
            <span
              v-if="
                chat.lastMessage.messageattachmentSet.length > 0 &&
                  chat.lastMessage.messageattachmentSet[0].type == 'IMAGE'
              "
              class="pr-1"
            >
              <v-icon> mdi-image </v-icon></span
            >
            <span v-if="chat.lastMessage.text">{{ truncate(chat.lastMessage.text) }}</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { truncate, capitalize, decodeId } from "@/lib/string";
export default {
  name: "ChatListingCard",
  props: {
    chat: {
      type: Object,
      required: true,
    },
    userId: {
      type: String,
      required: false,
    },
  },
  computed: {
    link() {
      return `${this.$appEndPoint}/chats/${decodeId(this.chat.id)}`;
    },
    timeAgo() {
      if (!this.chat.lastMessageTimestamp) {
        return null;
      }
      return this.$moment(this.chat.lastMessageTimestamp).fromNow();
    },
  },
  methods: {
    truncate(text) {
      return truncate(text, 50);
    },
    capitalize(text) {
      return capitalize(text);
    },
    clientLastRead(chat) {
      let userChat = null;
      if (this.userId) {
        userChat = chat.userchatSet.find((userChat) => userChat.user.id == this.userId);
      } else {
        userChat = chat.userchatSet.find((userChat) => userChat.user.isStaff == false);
      }
      if (userChat) {
        return userChat.lastViewedTimestamp ? this.$moment(userChat.lastViewedTimestamp).fromNow() : null;
      }
      return null;
    },
  },
};
</script>
